import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-button-toggle.css';

var getClassNameList = classNames.bind(styles);
var UitkButtonToggleGroup = function (props) {
    var children = props.children, className = props.className, wrapButtons = props.wrapButtons;
    var parentClasses = className;
    var wrapperClassName = getClassNameList('uitk-button-toggle-group', parentClasses, {
        'uitk-button-toggle-group-wrap': wrapButtons
    });
    return (React.createElement("div", { className: wrapperClassName }, React.Children.map(children, function (child) {
        var value = child && child.props && child.props.value;
        var checked = child && child.props && child.props.checked;
        var id = child && child.props && child.props.id;
        var name = child && child.props && child.props.name;
        var onChange = child && child.props && child.props.onChange;
        var altText = child && child.props && child.props.altText;
        var icon = child && child.props && child.props.icon;
        var label = child && child.props && child.props.label;
        var labelStyle = child && child.props && child.props.labelStyle;
        var labelText = child && child.props && child.props.labelText;
        var subLabelText = child && child.props && child.props.subLabelText;
        var iconSize = child && child.props && child.props.iconSize;
        var childClassName = child && child.props && child.props.className;
        var childClassNames = getClassNameList(childClassName, {
            'uitk-button-toggle-nowrap': !wrapButtons
        });
        return React.cloneElement(child, {
            altText: altText,
            checked: checked,
            className: childClassNames,
            icon: icon,
            iconSize: iconSize,
            id: id,
            label: label,
            labelStyle: labelStyle,
            labelText: labelText,
            name: name,
            onChange: onChange,
            subLabelText: subLabelText,
            value: value
        });
    })));
};
UitkButtonToggleGroup.displayName = 'UitkButtonToggleGroup';
UitkButtonToggleGroup.defaultProps = {
    wrapButtons: false
};

export { UitkButtonToggleGroup };
